import { useId, type ReactNode } from 'react';
import type { ChannexUnitPublicationRow } from '@/shared/api';
import { cn } from '@/shared/lib/cn';
import { UNIT_COLUMNS } from './PublicationUnitRow';

interface Props {
  units: ChannexUnitPublicationRow[];
  withSelect: boolean;
  hint?: string;
  /** Auswahl und „Auswahl veröffentlichen" — nur für den, der veröffentlichen darf. */
  selection?: ReactNode;
  renderRow: (unit: ChannexUnitPublicationRow) => ReactNode;
}

/**
 * Die Apartments des Objekts beim Kanalmanager. Eine Liste mit einem Raster je Zeile statt einer
 * Tabelle: schmal zweizeilig, breit einzeilig, und jede Steuerung steht nur einmal im Dokument.
 */
export function PublicationUnitList({ units, withSelect, hint, selection, renderRow }: Props) {
  const titleId = useId();
  return (
    <section
      aria-labelledby={titleId}
      className="border-line/50 bg-card shadow-card @container rounded-lg border"
    >
      <div className="border-line/60 flex flex-wrap items-center justify-between gap-3 border-b px-5 py-3">
        <div className="min-w-0">
          <h3 id={titleId} className="text-ink font-serif text-[19px] leading-tight">
            Apartments
          </h3>
          {hint && <p className="text-ink-soft mt-0.5 text-xs">{hint}</p>}
        </div>
        {selection && <div className="flex flex-wrap items-center gap-2">{selection}</div>}
      </div>
      <div
        aria-hidden
        className={cn(
          '@xl:grid border-line/60 text-ink-soft hidden gap-x-4 border-b px-5 py-2 text-[11px] font-semibold uppercase tracking-[0.08em]',
          withSelect ? UNIT_COLUMNS.select : UNIT_COLUMNS.plain,
        )}
      >
        {withSelect && <span />}
        <span>Apartment</span>
        <span>Kanalmanager</span>
        <span>Verkauf</span>
        <span />
      </div>
      <ul className="divide-line/60 divide-y">{units.map(renderRow)}</ul>
    </section>
  );
}
